import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { CloseIcon } from '../../icons';
import { Modal } from 'antd';

import './AirTabbedModal.css';

@inject('translationsStore')
@observer
export default class AirTabbedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  showTab = key => {
    this.setState({ key });
  };

  render() {
    const { visible, onOk, onCancel } = this.props;
    const { tabs } = this.props;

    let key = this.state.key || (tabs || [{}])[0].key;

    const tabbedTitle = (
      <Fragment>
        {tabs.map((tab, index) => {
          const color = this.props.color || 'var(--primary-color)';
          let style = { cursor: 'pointer' };
          if (tab.key === key) {
            style = { ...style, borderBottomColor: color, color };
          }
          return (
            <div key={index} style={style} onClick={() => this.showTab(tab.key)}>
              {tab.title}
            </div>
          );
        })}
      </Fragment>
    );

    return (
      <Modal {...this.props} visible={visible} className={`AirTabbedModal ${this.props.className}`} footer={null} onOk={onOk} onCancel={onCancel} closable={false}>
        <div className="title" style={this.props.titlebarStyle}>
          {tabbedTitle}
        </div>
        <div className="close">
          <CloseIcon onClick={this.props.onCancel} style={this.props.titlebarStyle} />
        </div>
        <div className="content" style={this.props.contentStyle}>
          {(tabs.find(tab => tab.key === key) || {}).render}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirTabbedModal/AirTabbedModal.js